import type { Schema } from '#core'
import type * as pub from '#core'
import type { NonOverlappingUnion } from '#internal'

import { BaseClip } from './base-clip.ts'

export interface ImageClip extends NonOverlappingUnion<BaseClip<Schema.ImageClip>, pub.ImageClip> {}

export class ImageClip extends BaseClip<Schema.ImageClip> implements pub.ImageClip {
  static FIELDS = super.FIELDS.concat(BaseClip.VISUAL_FIELDS satisfies pub.NodeFieldDef<pub.ImageClip>[])

  declare asset: pub.ImageAsset | undefined

  get linkedAudio(): pub.AudioClip | undefined {
    const linkItem =
      this.link?.nodes.length === 2 ? this.link.nodes.find((n) => n.type === 'clip:audio') : undefined
    return linkItem && this.doc.nodes.get(linkItem.id)
  }

  isImageClip(): this is ImageClip {
    return true
  }
  isVideo(): this is ImageClip {
    return true
  }

  toJSON(): Schema.ImageClip {
    const obj: Schema.ImageClip = {
      ...super.toJSON(),
      ...this._visualToJSON(),
    }

    return obj
  }
}
